(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  if (preference.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
  const active = new Set();
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (preference.matches || document.hidden) continue;
      const animation = entry.target.animate(
        [{ opacity: 0.9, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 380, easing: 'cubic-bezier(.22,.61,.36,1)' }
      );
      active.add(animation);
      animation.finished.then(() => active.delete(animation), () => active.delete(animation));
    }
  }, { threshold: 0.08 });
  const prepare = () => {
    document.querySelectorAll('.bw-daily-signs__card, .bw-amla-support__product, .ad-story__intro').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top > innerHeight + 20) observer.observe(element);
    });
  };
  const start = () => 'requestIdleCallback' in window ? requestIdleCallback(prepare, { timeout: 1500 }) : setTimeout(prepare, 100);
  if (document.readyState === 'complete') start();
  else addEventListener('load', start, { once: true });
  preference.addEventListener('change', event => {
    if (!event.matches) return;
    observer.disconnect();
    active.forEach(animation => animation.cancel());
    active.clear();
  });
})();
